import {helpers, maxLength, required, requiredIf} from 'vuelidate/lib/validators';
import store from '@/store/index';
import {CREATE_SHIPMENT_PREFIX, GETTERS} from '../store/constants';

const customMailValidator = (value) => !helpers.req(value) || (/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(value))

export default {
    accountNumber: {},
    name: {
        required: requiredIf((vm) => {
            return store.getters[
                CREATE_SHIPMENT_PREFIX + GETTERS.CREATE_SHIPMENT.HAS_SHIPPINGOPTIONS
            ] && !vm.isPrivate;
            
        }),
        maxLength: maxLength(50)
    },
    street1: {
        required: requiredIf(() => {
            return store.getters[
                CREATE_SHIPMENT_PREFIX + GETTERS.CREATE_SHIPMENT.HAS_SHIPPINGOPTIONS
            ];
        }),
        maxLength: maxLength(50)
    },
    street2: {
        maxLength: maxLength(50)
    },
    street3: {
        maxLength: maxLength(50)
    },
    postalCode: {
        maxLength: maxLength(10)
    },
    city: {
        required,
        maxLength: maxLength(50)
    },
    countryCode: {
        required
    },
    stateCode: {
        required: requiredIf((vm) => {
            if (vm.countryCode === 'US' || vm.countryCode === 'CA') {
                return true;
            }
            return false;
        })
    },
    contactPerson: {
        name: {
            required: requiredIf(() => {
                const hasShipmentOptions = store.getters['createShipment/hasShipmentOptions'];
                const viewOptions = store.getters['createShipment/getViewOptions'];

                const contactPerson = viewOptions.filter((opt) => {
                    return opt.name === 'NoContactPerson';
                });

                if (contactPerson.length === 0){
                    return hasShipmentOptions && false
                }

                return hasShipmentOptions && contactPerson[0].required;
            }),
            maxLength: maxLength(50)
        },
        phone: {

            required: requiredIf(() => {
                const hasShipmentOptions = store.getters['createShipment/hasShipmentOptions'];
                const viewOptions = store.getters['createShipment/getViewOptions'];

                const phone = viewOptions.filter((opt) => {
                    return opt.name === 'NoPhoneNo'
                });
                
                if (phone.length === 0){
                    return hasShipmentOptions && false   
                }
                
                return hasShipmentOptions && phone[0].required;
            }),
            maxLength: maxLength(50)
        },
        mails: {
            $each: {
               
                required: requiredIf(() => {
                    const hasShipmentOptions = store.getters['createShipment/hasShipmentOptions'];
                    const viewOptions = store.getters['createShipment/getViewOptions'];

                    const mails = viewOptions.filter((opt) => {
                        return opt.name === 'NoEmail';
                    });

                    if (mails.length === 0){
                        return hasShipmentOptions && false
                    }

                    return hasShipmentOptions && mails[0].required;
                }),
                maxLength: maxLength(50),
                email: customMailValidator
            }
        }
    }
};
